import { Route } from '@angular/router';
import { authGuard } from '@routes/guards/auth.guard';
import { guard } from '@routes/guards/guard-factory';

export const sportTypesRoutes: Route[] = [
    {
        path: 'sports',
        title: 'PRSS | Виды спорта',
        loadComponent: () =>
            import('@pages/guids/sport-types/sport-types.component').then(
                (c) => c.SportTypesComponent,
            ),
        canActivate: [authGuard, guard('watch_refs_sports')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Виды спорта', url: null },
            ],
            reuse: true,
            searchString: true,
        },
    },
    {
        path: 'sports/:id',
        title: 'PRSS | Вид спорта',
        loadComponent: () =>
            import('@pages/guids/sport-types/sport-type-details/sport-type-details.component').then(
                (c) => c.SportTypeDetailsComponent,
            ),
        canActivate: [authGuard, guard('watch_refs_sports')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Виды спорта', url: '/sports/' },
            ],
            searchString: false,
        },
    },
];
